export const ProductionSocketStage = (json: IProductionSocketStage): IProductionSocketStageModel => {
	const { short_name, machine_types, ...rest } = json

	return {
		...rest,
		shortName: short_name,
		machineTypes: machine_types ? machine_types.map(ProductionMachineType) : [],
	}
}

export const ProductionSocket = (json: IProductionSocket): IProductionSocketModel => {
	const { is_active, created_at, updated_at, stages, stages_count, ...rest } = json

	return {
		...rest,
		stages: stages ? stages.map(ProductionSocketStage) : [],
		stagesCount: stages_count,
		isActive: is_active,
		createdAt: new Date(created_at),
		updatedAt: new Date(updated_at),
	}
}

export const ProductionSocketStagePayload = (
	stage: IProductionSocketStageModel,
): IProductionSocketStagesCreatePayload => ({
	id: stage.id ? stage.id : undefined,
	name: stage.name,
	short_name: stage.shortName,
	machine_types: stage.machineTypes.map(type => type.id),
})

export const ProductionSocketToUpdatePayload = (
	model: IProductionSocketForm,
	id: number,
	stages: IProductionSocketStageModel[],
): IProductionSocketUpdatePayload => {
	const { name } = model

	return {
		name,
		id,
		stages: stages ? stages.map(stage => ProductionSocketStagePayload(stage)) : [],
	}
}

export const ProductionSocketToCreatePayload = (
	model: IProductionSocketForm,
	stages: IProductionSocketStageModel[],
): IProductionSocketCreatePayload => {
	const { name } = model

	return {
		name,
		stages: stages ? stages.map(stage => ProductionSocketStagePayload(stage)) : [],
	}
}

/**
 * Details models
 */
const ProductionSocketStageDetailsMachine = (
	json: IProductionSocketDetailsStageMachine,
): IProductionSocketDetailsStageMachineModel => {
	const { is_active, short_name, performance_parameters, ...rest } = json

	return {
		...rest,
		isActive: is_active,
		shortName: short_name,
		performanceParameters: performance_parameters
			? performance_parameters.map(ProductionMachinePerformanceParameter)
			: [],
	}
}

const ProductionSocketStageDetailsMachineType = (
	json: IProductionSocketDetailsStageMachineType,
): IProductionSocketDetailsStageMachineTypeModel => {
	const { is_active, machines, updated_at, product_types, created_at, ...rest } = json

	return {
		...rest,
		isActive: is_active,
		productTypes: product_types ? product_types.map(ProductionProductType) : [],
		machines: machines ? machines.map(ProductionSocketStageDetailsMachine) : [],
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const ProductionSocketStageDetails = (
	json: IProductionSocketDetailsStage,
): IProductionSocketDetailsStageModel => {
	const { short_name, machine_types, ...rest } = json

	return {
		...rest,
		shortName: short_name,
		machineTypes: machine_types ? machine_types.map(ProductionSocketStageDetailsMachineType) : [],
	}
}

export const ProductionSocketDetails = (json: IProductionSocketDetails): IProductionSocketDetailsModel => {
	const { id, name, is_active, stages, updated_at, created_at } = json

	return {
		id,
		name,
		isActive: is_active,
		stages: stages ? stages.map(ProductionSocketStageDetails) : [],
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

/**
 * Forms
 */
const ProductionSocketManageTypesToModel = (
	types: IProductionSocketStageMachineModelOptions[],
): IProductionMachineTypeModel[] =>
	types.map(type => ({
		id: type.value,
		name: type.label,
	}))

export const ProductionSocketMangeToModel = (
	event: IFormSubmitEvent<IProductionSocketStageForm>,
	types: IProductionSocketStageMachineModelOptions[],
	socketStageId?: number,
): IProductionSocketStageModel => {
	const { name, shortName } = event.values

	return {
		name,
		shortName,
		id: socketStageId ?? 0,
		machineTypes: types ? ProductionSocketManageTypesToModel(types) : [],
	}
}
